
import { reactive, ref, toRefs, defineComponent, onMounted,nextTick ,watch} from "vue";
interface timesdurion  {
    timesnewfen:Array<any>;
    timesnewmiao:Array<any>;
    timeflage:boolean;
    overindex:any,
    overmiaoindex:any,
    defaultValuefen:null|number;
    defaultValuemiao:null|number;
}
// interface contentemit{
//     emit:(event:string,...args:unknown[])=>void
// }
import { ElMessage } from 'element-plus'
export default defineComponent({
    emits:['timesvaluedurion'],
    setup(prop,content) {
      let timelefts = ref<any|HTMLElement>(null)
      let timerights = ref<any|HTMLElement>(null)
      const timedurion:timesdurion = reactive({
          timesnewfen:[],
          timesnewmiao:[],
          timeflage:false,
          overindex:1,
          overmiaoindex:0,
          defaultValuefen:1,
          defaultValuemiao:0
      })
      const methods = reactive({
          overs:(item:number|string,index:number)=>{
              timedurion.overindex = index
          },
          oversmiao:(item:number|string,index:number)=>{
              timedurion.overmiaoindex = index
          },
          outs:()=>{
          },
          cancels(){
             timedurion.overindex =  timedurion.defaultValuefen
             timedurion.overmiaoindex = timedurion.defaultValuemiao
             timedurion.timeflage = false
          },
          comfrims(){
            if (timedurion.overindex===0&&timedurion.overmiaoindex === 0) {
                 ElMessage({
                  message:'消杀时间不可为0'
                })
                return
            }
            console.log(timedurion.overindex,timedurion.overmiaoindex)
            content.emit('timesvaluedurion',timedurion.overindex,timedurion.overmiaoindex)
            // timelefts.value.scrollTop = timedurion.overindex *15
            timedurion.defaultValuefen = timedurion.overindex
            timedurion.defaultValuemiao = timedurion.overmiaoindex
            timedurion.timeflage = false
          },
          setleftscrlotop(values:number) {
              timelefts.value.scrollTop = (20 * values) - 40
              console.log(timelefts.value.scrollTop)
          },
          setrightscrlotop(values:number) {
              console.log(values)
              timerights.value.scrollTop = (20 * values) - 40
              console.log(timerights.value.scrollTop)
          }
      })
      onMounted(()=>{
          for(let i=0;i<60;i++){
              timedurion.timesnewfen.push(i<10?'0'+i:i)
          }
          for(let ii=0;ii<60;ii++){
              timedurion.timesnewmiao.push(ii<10?'0'+ii:ii)
          }
        nextTick(()=>{
            console.log(timelefts.value.scrollTop)
             watch(timedurion,(newold:any)=>{
             methods.setleftscrlotop(newold.overindex)
             methods.setrightscrlotop(newold.overmiaoindex)
            },
            {deep:true},
            )
        })
      })
      return {
          ...toRefs(timedurion),
          ...toRefs(methods),
          timelefts,
          timerights
      }
    }
})
